import { createSlice } from '@reduxjs/toolkit';
import { fetchWelcome, fetchApp } from './welcome-thunk';
import { AsyncStatus } from '../../constants/async-status';
import IWelcome from './welcome-interface';

const initialState = {
    asyncStatus: AsyncStatus.INITIAL,
    version: '',
} as IWelcome;

const welcomeSlice = createSlice({
    name: 'welcome',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchWelcome.pending.type]: (state: IWelcome) => {
            state.asyncStatus = AsyncStatus.LOADING;
        },
        [fetchWelcome.fulfilled.type]: (state: IWelcome, { payload }: any) => {
            state.asyncStatus = AsyncStatus.SUCCESS;
            state.version = payload;
        },
        [fetchWelcome.rejected.type]: (state: IWelcome) => {
            state.asyncStatus = AsyncStatus.FAILURE;
        },
        [fetchApp.pending.type]: (state: IWelcome) => {
            state.asyncStatus = AsyncStatus.LOADING;
        },
        [fetchApp.fulfilled.type]: (state: IWelcome, { payload }: any) => {
            state.asyncStatus = AsyncStatus.SUCCESS;
            state.version = payload;
        },
        [fetchApp.rejected.type]: (state: IWelcome) => {
            state.asyncStatus = AsyncStatus.FAILURE;
        },
    },
});

export default welcomeSlice.reducer;
